'use client'

import Button from '@/components/Button/Button'
import classNames from 'classnames'
import styles from './Toggle.module.scss'

export type ToggleProps = {
  className?: string
  items: (string | undefined)[]
  value: string | undefined
  id?: string
  name: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Toggle = ({ className, items, value, onChange, name }: ToggleProps) => {
  return (
    <div className={classNames(styles.Toggle, className)}>
      {items.map(item => {
        if (!item) return null

        const isActive = item === value

        return (
          <div
            key={item}
            className={styles.option}
          >
            <input
              type="radio"
              hidden
              id={item}
              name={name}
              value={item}
              checked={isActive}
              onChange={onChange}
              className={styles.radioInput}
            />
            <label
              htmlFor={item}
            >
              <Button
                className={styles.button}
                primary={isActive}
                secondary={!isActive}
                label={item}
                element="span"
              />
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default Toggle
